<div class="card-actions" *ngIf="actions?.length">
  <button
    type="button"
    class="card-action-chip"
    [ngClass]="'card-action-chip--' + a.kind"
    *ngFor="let a of actions; trackBy: trackAction"
    (click)="onTap(a)"
    (keydown)="onKeydown($event, a)">
    <ion-icon class="card-action-chip__icon" [name]="actionIcon(a)" aria-hidden="true"></ion-icon>
    <span class="card-action-chip__label">{{ a.label }}</span>
  </button>
</div>
